import { fetcher } from "src/utils/axios";

/** A typed office link selects an existing domain record; it never grants access. */
export function officeSourceId(kind: string, provider: number): number {
  const query = new URLSearchParams(window.location.search);
  const id = Number(query.get("office_source"));
  return query.get("office_kind") === kind && Number(query.get("office_provider")) === provider && Number.isSafeInteger(id) && id > 0 ? id : 0;
}
export async function officeSourcePage(input: Parameters<typeof fetcher>[0]) {
  const record = await fetcher(input);
  return { items: [record], total: 1, offset: 0, limit: 20 };
}
